import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {companySchema} from '../utils/schemas/company';

import {companyKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getCompany = async () => {
  const data = await api.get(`companies`).json();
  return companySchema.parse(data);
};

export const useCompany = (config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: companyKeys.all,
    queryFn: () => getCompany(),
  });
};
export const useCompanyLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getCompany;
